import React from 'react';
import { Drawer, Box, Typography, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { layout } from '../../themes/smartinventoryTheme';

// Right-side drawer for every create/edit flow — replaces most CRUD
// Dialogs. Header (title + subtitle + close), scrolling body, footer with
// Cancel (left) + the one primary action (right) pinned. Full-width below 900px.
const EntityDrawer = ({
  open,
  onClose,
  wide,
  title,
  subtitle,
  closeLabel,
  cancelLabel,
  primaryLabel,
  onPrimary,
  primaryDisabled,
  loading,
  children,
}) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        width: { xs: '100%', sm: wide ? layout.drawerWidthWide : layout.drawerWidth },
        display: 'flex',
        flexDirection: 'column',
      },
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2.5, borderBottom: '1px solid', borderColor: 'divider' }}>
      <Box>
        <Typography variant="h6">{title}</Typography>
        {subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
      </Box>
      <IconButton onClick={onClose} aria-label={closeLabel}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
    <Box sx={{ flex: 1, overflowY: 'auto', p: 2.5 }}>
      {children}
    </Box>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1.25, p: 2.5, borderTop: '1px solid', borderColor: 'divider' }}>
      <Button variant="text" onClick={onClose} disabled={loading}>{cancelLabel}</Button>
      <Button variant="contained" onClick={onPrimary} disabled={primaryDisabled || loading}>{primaryLabel}</Button>
    </Box>
  </Drawer>
);

export default EntityDrawer;
